
export function  debounce(fn,duration=100){
    let timer=null
    return (...args)=>{
        // console.log(321)
        clearTimeout(timer)
        timer=setTimeout(()=>{
            fn(...args);
        },duration)
 
    }
}
export function throttle(fn,duration=100){
    let target=true;
    return (...arg)=>{
        if(!target){
            return false;
        }
        target =false;
        setTimeout(()=>{
            fn(...arg);
            target=true
        },duration)
    }
}

export function getDomainGameId() {
    if (typeof window === 'undefined' || !window.location) {
        return null;
    }

    const host = window.location.hostname.replace(/^www\./, '').toLowerCase();
    const domainGameMap = {
        'boxh5.277007.com': 9,
        '66520.com': 0,
    };

    return Object.prototype.hasOwnProperty.call(domainGameMap, host) ? domainGameMap[host] : null;
}

export function filterDomainGameList(list, idKey) {
    const domainGameId = getDomainGameId();

    if (domainGameId === null || !Array.isArray(list)) {
        return list;
    }

    return list.filter((item) => Number(item[idKey]) === domainGameId);
}
